"use client";
import dynamic from "next/dynamic";
import { useEffect, useState } from "react";
import BackToTop from "../elements/BackToTop";
import Breadcrumb from "./BreadcrumbSmall";
import Footer1 from "./footer/Footer1";
import Header2 from "./header/Header2";
import OffcanvasMobileMenu from "./Offcanvas";
import Search from "./Search";
import WhatsAppButton from "@/components/WhatsAppButton";
import BookedSolidChat from "@/components/BookedSolidChat";

import CookieBanner from "@/components/CookieBanner";
const Accordion = dynamic(() => import("../elements/collapseFunc"), {
  ssr: false,
});

export default function Layout({
  breadcrumbTitle,
  children,
  mainContentCls,
  breadcrumbAlt,
}) {
  const [scroll, setScroll] = useState(0);
  // Moblile Menu
  const [isMobileMenu, setMobileMenu] = useState(false);
  const handleMobileMenu = () => setMobileMenu(!isMobileMenu);
  const [isSearch, setSearch] = useState(false);
  const handleSearch = () => setSearch(!isSearch);

  useEffect(() => {
    // new WOW.WOW({
    //   live: false,
    // }).init();

    const onScroll = () => {
      setScroll(window.scrollY > 100);
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <>
      <div id="top" />
      <Accordion />
      <div id="wrapper">
        <Header2
          scroll={scroll}
          isSearch={isSearch}
          handleSearch={handleSearch}
        />
        {breadcrumbTitle && (
          <Breadcrumb
            breadcrumbTitle={breadcrumbTitle}
            breadcrumbAlt={breadcrumbAlt}
          />
        )}

        <div className={mainContentCls ? mainContentCls : "main-content-2"}>
          {children}
        </div>
        <Footer1 />
      </div>
      <OffcanvasMobileMenu
        isMobileMenu={isMobileMenu}
        handleMobileMenu={handleMobileMenu}
      />
      <Search isSearch={isSearch} handleSearch={handleSearch} />
      <BackToTop target="#top" />

      <WhatsAppButton />
      <BookedSolidChat
        clientId={process.env.NEXT_PUBLIC_BOOKEDSOLID_CLIENT_ID}
        autoOpen={"false"}
      />
      <CookieBanner />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            serviceType: "EarWax Removal",
            description:
              "Professional earwax removal services using microsuction and water irrigation.",
            provider: {
              "@type": "LocalBusiness",
              name: "Pro Ear Clinic",
              address: {
                "@type": "PostalAddress",
                streetAddress: "The Hampton SpA, Beggar Bush Ln, Failand",
                addressLocality: "Bristol",
                addressRegion: "Bristol",
                postalCode: "BS8 3TG",
                addressCountry: "UK",
              },
            },
            image: [
              "https://proearclinic.co.uk/images/logo/Logo-pro-ear-clinic.svg",
              "https://images.prismic.io/pro-ear-clinic/aSd6fWGnmrmGqZEh_redwood-entrance.jpg?auto=format%2Ccompress&fit=max&w=1240",
            ],

            telephone: "+441174410770",
            priceRange: "££",
            areaServed: ["Bristol"],
          }),
        }}
      />
    </>
  );
}
